module.exports = "/assets/data/e02889497bb8ee86493e42a515ec16e8-B67.data.json";